import AppUtils from "./AppUtils";
import * as _ from "lodash";
import {BROWSER_NAME} from "./AppConstants";

class BrowserUtils {

    static isChrome() {
        try {
            // const fallbackToUserAgent = ((navigator.userAgent.toLowerCase().indexOf("chrome") > -1) && (navigator.vendor.toLowerCase().indexOf("google") > -1) && (navigator.userAgent.toLowerCase().indexOf("opr") === -1));
            return window && !!_.get(window, "chrome")
        } catch (e) {
            console.log("Browser Detection Error:", e)
            return null
        }
    }

    static isEdge() {
        return (navigator.userAgent.toLowerCase().indexOf("edg") > -1)
    }

    static isOpera() {
        return ((!!window.opr && !!opr.addons) ||
            !!window.opera || navigator.userAgent.toLowerCase().indexOf("opr") > -1)
    }

    static isIos(): boolean {
        const platform: string = navigator.platform.toLowerCase();
        if (platform.includes("iphone") || platform.includes("ipad") || platform.includes("ipod")) {
            return true;
        }
        return false;
    }

    static isSafari(): boolean {
        const safariFlag = /constructor/i.test(window.HTMLElement) ||
        ((p: any) => {
            return p.toString() === "[object SafariRemoteNotification]";
        })(
            !window.safari ||
            (typeof safari !== "undefined" && safari.pushNotification)
        )
        if (safariFlag) return safariFlag
        else {
            const browserVendor: string = navigator.vendor.toLowerCase();
            return browserVendor.includes("apple");
        }
    }
    static isChromeOnIos() {
        return navigator.userAgent.match('CriOS');
    }
    static isCompatibleBrowser() {
        const isChrome = this.isChrome()
        const isIos = this.isIos();
        const isSafari = this.isSafari();
        const isChromeOnIos = this.isChromeOnIos();
        if (isIos && isChromeOnIos) {
            return false;
        } else if (isIos && isSafari) {
            return true;
        } else {
            return AppUtils.isDefined(isChrome)
                ? isChrome && !this.isEdge() && !this.isOpera()
                : true;
        }
    }

    static getBrowserName() {
        try {
            // Opera 8.0+
            const isOpera = this.isOpera();

            // Firefox 1.0+
            const isFirefox = typeof InstallTrigger !== "undefined";

            // Safari 3.0+ "[object HTMLElementConstructor]"
            const isSafari = this.isSafari()

            // Internet Explorer 6-11
            const isIE = /*@cc_on!@*/ false || !!document.documentMode;

            // Edge 20+
            const isEdge = !isIE && !!window.StyleMedia;

            const isChrome = this.isChrome()

            // Edge (based on chromium) detection
            const isEdgeChromium =
                isChrome && navigator.userAgent.indexOf("Edg") !== -1;

            // Blink engine detection
            const isBlink = (isChrome || isOpera) && !!window.CSS;

            if (isOpera) {
                return BROWSER_NAME.opera;
            }
            if (isFirefox) {
                return BROWSER_NAME.firefox;
            }
            if (isSafari) {
                return BROWSER_NAME.safari;
            }
            if (isIE) {
                return BROWSER_NAME.internetExplorer;
            }
            if (isEdge) {
                return BROWSER_NAME.edge;
            }
            if (isEdgeChromium) {
                return BROWSER_NAME.edgeChromium;
            }
            if (isChrome) {
                return BROWSER_NAME.chrome;
            }
            if (isBlink) {
                return BROWSER_NAME.blink;
            }

            return BROWSER_NAME.other;
        } catch (err) {
            return BROWSER_NAME.other;
        }
    }
}

export default BrowserUtils